import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPointV3 } from '@retailer-platform/dashboard/routing'

import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { sandboxRouter } from './routing/sandboxRouter'
import { sandboxAccessControl } from './access-control/sandboxAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'sandbox',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component.
    // Reuses the existing Storefront (SFP) Totem entity — no dedicated sandbox entity needed yet.
    tool: 'storefront-dashboard-tool',
  },
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
    // Non-en locale files are managed by the i18n workflow (go/translation-process),
    // not edited directly here; keys they lack fall back to en-US until the pipeline fills them.
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [sandboxRouter],
  },
  navigationEntries: [
    {
      // SFP-only and SF+SFP retailers see the sandbox tool under the SFP L1.
      attachToV3: NavEntryPointV3.StorefrontPro,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Provision and manage the SFP Sandbox environment for this retailer',
          labelId: 'sandboxDomain.nav',
          route: 'sandbox',
          accessControl: sandboxAccessControl,
          positionNavV3: 20,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
